import React from "react";

const ButtonFluid = ({ onClick, id, name, label, disabled = false }) => {
  return (
    <button
      id={id}
      name={name}
      onClick={onClick}
      disabled={disabled}
      className="w-full font-lato text-center border-2  border-solid bg-secondary-color border-secondary-color transition-all text-white hover:bg-[#043b48] hover:border-[#043b48]  ease-in-out duration-200 active:bg-secondary-color active:border-secondary-color rounded-[0.675rem] p-[0.675rem]"
    >
      {label}
    </button>
  );
};

export default ButtonFluid;
